<template>
  <div>
    <v-container class="pa-0">
      <v-row v-if="secondsTill < 0">
        <v-col>
          <div v-if="!endShowLink">{{endText}}</div>
          <div v-if="endShowLink">
            <v-icon
              left
              dark
              color="red"
              v-if="!entry.answered || !entry.voted"
            >
              mdi-alert
            </v-icon>
            <v-icon
              left
              dark
              color="green"
              v-if="entry.answered && entry.voted"
            >
              mdi-check-circle
            </v-icon>
            <router-link :to="{name: linkName, query: {entryId: entry.id}}">{{linkText}}</router-link>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="secondsTill >= 0">
        <v-col class="pb-1" style="text-align: center;">
          <div class="mb-1 mt-1">{{title}}:</div>
          <table style="margin-left:auto;margin-right:auto">
            <tr class="countdown-seg">
              <td>Days</td>
              <td>Hrs</td>
              <td>Min</td>
              <td>Sec</td>
              <td rowspan="2" class="honey-colour" style="padding-top:10px;padding-left:5px;font-size:14px;">@ {{displayTime}}</td>
            </tr>
            <tr>
              <td>
                <div :class="blockClass">{{duration.days()}}</div>
              </td>
              <td><div :class="blockClass">{{duration.hours()}}</div></td>
              <td><div :class="blockClass">{{duration.minutes()}}</div></td>
              <td><div :class="blockClass">{{duration.seconds()}}</div></td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row v-if="entry && secondsTill >= 0">
        <v-col align="center">
          <router-link :to="{name: 'entry-home', query: {entryId: entry.id}}">View entry details here</router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data: () => ({
    secTimeout: null,
    duration: null,
    secondsTill: null
  }),
  name: 'CountdownClock',
  props: ['title','date','blockClass','endText','endShowLink','linkText','linkName','entry','displayTime'],
  methods: {
    processSecond: function () {
      var scope = this;
      scope.secondsTill = moment(scope.date).unix() - moment().unix();
      if(scope.secondsTill > 0) {
        var duration = moment.duration(this.secondsTill*1000, 'milliseconds');
        var interval = 1000;
        duration = moment.duration(duration - interval, 'milliseconds');
        scope.duration = duration;

        this.secTimeout = setTimeout(() => {
          if(scope.secondsTill > 0){
            scope.processSecond();
          } else {
            clearTimeout(this.secTimeout);
          }        
        }, 1000);
      } else {
        scope.secondsTill = -1;
        clearTimeout(this.secTimeout);
      }
    }
  },
  created () {
    this.processSecond();
  },
  beforeDestroy() {
    if(this.secTimeout !== null){
      clearTimeout(this.secTimeout);
    }
  },
}
</script>
